import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RequireAuth from 'features/auth/RequireAuth';
import Customer from 'views/customer';
import SalesRecord from 'views/salesRecord';
import MasterDataManagement from 'views/masterDataManagement';
import DailyPayoutRecords from 'views/dailyPayoutRecords';
import ReferralDetails from 'views/referralDetails';
import PackageItemRecords from 'views/packageItemRecords';
import ExpensesRecords from 'views/expensesRecords';
import CreateCustomer from 'views/customer/createCustomer';
import UsersRecord from 'views/users';
import Withdrawal from 'views/withdrawal';
import Adjustment from 'views/adjustment';
import CustomerTransactions from 'views/customerTransactions';
import SalesLockRecord from 'views/salesLockRecord';
import BinaryDetailRecord from 'views/binaryDetailsRecord';
import SContent from 'views/sContent';
import Tasklist from 'views/tasklist';
import CustomerTasklist from 'views/customerTasklistRecords';
import Drivers from 'views/drivers';
import Addresses from 'views/addresses';
import ReferralRequests from 'views/referralRequests';
import PayoutRequests from 'views/payoutRequests';
import ThirdPartyReport from 'views/thirdPartyReport';
import ReferralTeamSales from 'views/referralTeamSales';
import TeamIncentiveProfit from 'views/teamIncentiveProfit';
import AmbassadorClaims from 'views/ambassadorClaims';
import LockSalesProfit from 'views/lockSalesProfit';
import ShopPurchase from 'views/shopPurchase';
import Payment from 'views/payment';
import RankingProfit from 'views/rankingProfit';
import Deposit from 'views/deposit';
import Transfer from 'views/transfer';
import MissionClaims from 'views/missionclaims';
import FollowUpReport from 'views/followUpReport';
import AmbassadorDeposit from 'views/ambassadorDeposit';
import Notification from 'views/notification';
import EarnWalletInvestment from 'views/earnWalletInvestment';
import EarnWalletProfit from 'views/earnWalletProfit';
import EarnWalletWithdrawal from 'views/earnWalletWithdrawal';
import AmbassadorLevel from 'views/ambassadorLevel';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    element: <RequireAuth />,
    children: [
        {
            path: '/',
            element: <MainLayout />,
            children: [
                {
                    path: 'home',
                    element: <DashboardDefault />
                },
                {
                    path: 'customer',
                    element: <Customer />
                },
                {
                    path: 'customer/createCustomer',
                    element: <CreateCustomer />
                },
                {
                    path: 'salesRecord',
                    element: <SalesRecord />
                },
                {
                    path: 'masterDataManagement',
                    element: <MasterDataManagement />
                },
                {
                    path: 'dailyPayoutRecords',
                    element: <DailyPayoutRecords />
                },
                {
                    path: 'payoutRequests',
                    element: <PayoutRequests />
                },
                {
                    path: 'package',
                    element: <PackageItemRecords />
                },
                {
                    path: 'expensesRecords',
                    element: <ExpensesRecords />
                },
                {
                    path: 'users',
                    element: <UsersRecord />
                },
                {
                    path: 'withdrawal',
                    element: <Withdrawal />
                },
                {
                    path: 'referralDetails',
                    element: <ReferralDetails />
                },
                {
                    path: 'referralRequests',
                    element: <ReferralRequests />
                },
                {
                    path: 'adjustment',
                    element: <Adjustment />
                },
                {
                    path: 'customerTransactions',
                    element: <CustomerTransactions />
                },
                {
                    path: 'salesLockRecord',
                    element: <SalesLockRecord />
                },
                {
                    path: 'binary-income',
                    element: <BinaryDetailRecord />
                },
                {
                    path: 's-content',
                    element: <SContent />
                },
                {
                    path: 'tasklistManagement',
                    element: <Tasklist />
                },
                {
                    path: 'customerTasklistManagement',
                    element: <CustomerTasklist />
                },
                {
                    path: 'drivers',
                    element: <Drivers />
                },
                {
                    path: 'addresses',
                    element: <Addresses />
                },
                {
                    path: 'thirdPartyReport',
                    element: <ThirdPartyReport />
                },
                {
                    path: 'referralTeamSales',
                    element: <ReferralTeamSales />
                },
                {
                    path: 'teamIncentiveProfit',
                    element: <TeamIncentiveProfit />
                },
                {
                    path: 'ambassadorClaims',
                    element: <AmbassadorClaims />
                },
                {
                    path: 'lockSalesProfit',
                    element: <LockSalesProfit />
                },
                {
                    path: 'shop-purchase',
                    element: <ShopPurchase />
                },
                {
                    path: 'payment',
                    element: <Payment />
                },
                {
                    path: 'rankingProfits',
                    element: <RankingProfit />
                },
                {
                    path: 'deposit',
                    element: <Deposit />
                },
                {
                    path: 'transfer',
                    element: <Transfer />
                },
                {
                    path: 'missionClaims',
                    element: <MissionClaims />
                },
                {
                    path: 'followUpReport',
                    element: <FollowUpReport />
                },
                {
                    path: 'ambassadorDeposit',
                    element: <AmbassadorDeposit />
                },
                {
                    path: 'notification',
                    element: <Notification />
                },
                {
                    path: 'earnWalletInvestment',
                    element: <EarnWalletInvestment />
                },
                {
                    path: 'earnWalletProfit',
                    element: <EarnWalletProfit />
                },
                {
                    path: 'earnWalletWithdrawal',
                    element: <EarnWalletWithdrawal />
                },
                {
                    path: 'ambassadorLevel',
                    element: <AmbassadorLevel />
                },
            ]
        }
    ]
};

export default MainRoutes;
